// extracted by mini-css-extract-plugin
module.exports = {"overlay":"menu_overlay__2zs8K","open":"menu_open__i5XNT","container":"menu_container__2Uvsj"};